var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStatLearners = function SvgStatLearners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.5 14.375c3.573 0 6.469-2.789 6.469-6.23 0-3.44-2.896-6.228-6.469-6.228-3.573 0-6.469 2.789-6.469 6.229s2.896 6.229 6.469 6.229Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    d: "m7.207 12.957-.01 7.072c0 .863.604 1.284 1.351.93l2.569-1.217a.992.992 0 0 1 .776 0l2.578 1.217c.738.345 1.351-.067 1.351-.93v-7.245"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#A6A5A3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m7.207 12.957-.01 7.072c0 .863.604 1.284 1.351.93l2.569-1.217a.992.992 0 0 1 .776 0l2.578 1.217c.738.345 1.351-.067 1.351-.93v-7.245"
  }))));
};
export default SvgStatLearners;